/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('EventDataCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'Notification', '$timeout', function ($rootScope, $scope, $http, NetworkService, MainService, Notification, $timeout) {

        $scope.showEditWindow = true;
        $scope.bildChanged = false;
        $(document).ready(function () {
            $('#eventDate-from').bootstrapMaterialDatePicker({format: 'YYYY-MM-DD HH:mm:ss'});
            $('#eventDate-to').bootstrapMaterialDatePicker({format: 'YYYY-MM-DD HH:mm:ss'});
        })


        $rootScope.$on("openEditMode", function () {
            $scope.sendPicToEditCtrl();
            $scope.showEditMode();
        })

        $scope.showEditMode = function ()
        {
            $scope.showEditWindow = false;
        }

        $scope.success = function (msg) {
            Notification.success(msg);
        };
        NetworkService.getStatistics($scope.event.event_id, function (d) {
            $scope.event.statistic = d;
        })



        NetworkService.getGroupsForEvent($scope.event.event_id, function (data) {
            console.log("--#äpo")
            console.log(data)
            console.log(groupsObj)
            var groupsObj = {groupsInRead: [],
                groupsInWrite: [],
                groupsInManage: []}
            console.log(groupsObj)
            data.forEach(function (group) {
                if (group.level == 1)
                {
                    groupsObj.groupsInRead.push(group)
                } else if (group.level == 2)
                {
                    groupsObj.groupsInWrite.push(group)
                } else if (group.level == 3)
                {
                    groupsObj.groupsInManage.push(group)
                }
            })
            console.log(groupsObj)
            $rootScope.$emit("setAllGroupMembers", groupsObj)
        })
        $scope.renderDate = function (date)
        {
            datetime = "";

            try
            {
                var myDate = new mDate(date)
                var date = myDate.getDate();
                var time = myDate.getTime();
                var datetime = date + " " + time
            } catch (Exception)
            {

            }
            return datetime;
        }
        $scope.error = function (msg) {
            Notification.error(msg);
        };


        $scope.getGastLink = function (event_id)
        {
            NetworkService.getGastLink(event_id, function (data) {
                window.prompt("In die Zwischenablage Kopieren: Strg+C", data.data.link);
            })
        }
        $scope.sendPicToEditCtrl = function ()
        {
            var picIsThere = false
            try
            {
                var img = $("#eventImgFull")[0]
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL("image/png");
                picIsThere = true
            } catch (e)
            {
                console.log(e)
            }
            if (picIsThere)
            {
                MainService.setProfilePic(dataURL);
                $rootScope.$emit("setEventImage");
            }
        }


        $scope.picEdited = function ()
        {
            $scope.bildChanged = true;
        }
        $scope.updateEvent = function ()
        {
            var img = MainService.getProfilePic()
            $rootScope.$emit("getGroupMembers")
            var groups = MainService.getEventData()
            var data = {veranstaltung_id: $scope.event.event_id,
                eventname: $scope.event.eventname,
                veranstaltungsort: $scope.event.veranstaltungsort,
                veranstaltungsadresse: $scope.event.strasse,
                nr: $scope.event.hausnummer,
                veranstaltung_freigegeben: $scope.publishState,
                start: $scope.event.start,
                ende: $scope.event.ende,
                email: $scope.event.email,
                img: img,
                groups: groups}

            if (!$scope.bildChanged)
            {
                var img = $("#eventImgFull")[0]
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL("image/png");
                //window.open(dataURL)
                data.img = dataURL
            } else
            {

            }
            NetworkService.updateEvent(data, function (data) {
                if (data.done)
                {
                    $scope.success("Event erfolgreich geändert")
                }
            })
            $scope.showEditWindow = true;
        }

        $scope.getEventImage = function ()
        {
            var str = "imgs/eventImgs/event_" + $scope.event.event_id + ".png"
            return str;
        }

        $scope.addFoodKey = function (event)
        {
            if (event.key == "Enter")
            {
                $scope.foods.push($scope.addFood)
                NetworkService.updateFoodInEvent($scope.event.event_id, $scope.foods, function (data) {
                    console.log(data)
                })
            }

        }

        $scope.removeFood = function (delFood)
        {
            var foods = []
            $scope.foods.forEach(function (food) {
                if (food != delFood)
                {
                    foods.push(food)
                }
            })
            $scope.foods = foods
            NetworkService.updateFoodInEvent($scope.event.event_id, $scope.foods, function (data) {
                console.log(data)
            })
        }
        $scope.changePublishState = function ()
        {
            newState = $scope.publishState
            event_id = $scope.event.event_id
            console.log($scope.event)
            console.log(event_id)
            NetworkService.updatePublishState(event_id, newState)

        }
        console.log("###")
        NetworkService.getEventDetails(MainService.getEventData().event_id, function (d) {
            console.log(d)
        })
        $scope.event = MainService.getEventData()


        NetworkService.getFoodForEvent($scope.event.event_id, function (data) {
            $scope.foods = data.data
        })

        /* $scope.eventDateFrom = $scope.event.start
         $scope.eventDateTo = $scope.event.ende
         $scope.eventOrt = $scope.event.veranstaltungsort
         $scope.eventAdress = $scope.event.veranstaltungsadresse
         $scope.eventName = $scope.event.eventname*/

        $scope.publishState = ($scope.event.veranstaltung_freigegeben == 1)

        $scope.error = function (msg) {
            Notification.error(msg);
        };

    }])